export type Browser = "chrome" | "firefox" | "safari" | "edge" | "other";

const { userAgent } = navigator;

// Order matters a lot here. Edge's user agent contains "Chrome/" and "Safari/",
// and Chrome's user agent contains "Safari/".
export let browser: Browser = "other";
// NOT a typo. It actually is "Edg/" not "Edge/".
if (userAgent.includes("Edg/")) {
  browser = "edge";
} else if (userAgent.includes("Chrome/")) {
  browser = "chrome";
} else if (userAgent.includes("Firefox/")) {
  browser = "firefox";
} else if (userAgent.includes("Safari/")) {
  browser = "safari";
}
